import { render } from "./LinkAndUnlinkCompanyDiscountGroupsModal.html?vue&type=template&id=a076c2a4&scoped=true"
import script from "./LinkAndUnlinkCompanyDiscountGroupsModal.js?vue&type=script&lang=js"
export * from "./LinkAndUnlinkCompanyDiscountGroupsModal.js?vue&type=script&lang=js"

import "./LinkAndUnlinkCompanyDiscountGroupsModal.css?vue&type=style&index=0&id=a076c2a4&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a076c2a4"]])

export default __exports__